import { Box, Typography } from "@mui/material";
import { useGetBusinessesByUserIdQuery } from "lib/features/business/businessService";
import { User } from "lib/features/user/types";
import { useEffect, useState } from "react";
import { businessCheckout } from "styles/Checkout/multiBusinessCheckout";
import { parseImageUrl } from "util/parseImageUrl";

interface CheckoutHeaderProps {
  userData: User;
  listHeadline: string;
}

interface UserDisplayData {
  name: string;
  avatar?: string;
  isBusiness?: boolean;
}

export const CheckoutHeader = ({
  userData,
  listHeadline,
}: CheckoutHeaderProps) => {
  const [userDisplayData, setUserDisplayData] = useState<UserDisplayData | null>(null);

  const { data: businessData } = useGetBusinessesByUserIdQuery(
    { id: userData?.id ?? null },
    { skip: !userData?.id || userData?.role_id !== 4 }
  );

  useEffect(() => {
    const fetchUserDisplayData = async () => {
      if (userData) {
        const isBusiness = userData.role_id === 4;
        
        if (isBusiness && businessData) {
          const businesses = Array.isArray(businessData) 
            ? businessData 
            : [businessData];
          
          if (businesses.length > 0) {
            const business = businesses[0];
            setUserDisplayData({
              name: business?.business || `${userData.first_name} ${userData.last_name}`,
              avatar: business?.businessImages?.[0]?.uri
                ? parseImageUrl(business.businessImages[0].uri)
                : userData.avatar 
                  ? parseImageUrl(userData.avatar)
                  : undefined,
              isBusiness: true
            });
          } else {
            setUserDisplayData({
              name: `${userData.first_name} ${userData.last_name}`,
              avatar: userData.avatar ? parseImageUrl(userData.avatar) : undefined,
              isBusiness: true
            });
          }
        } else {
          setUserDisplayData({
            name: `${userData.first_name} ${userData.last_name}`,
            avatar: userData.avatar ? parseImageUrl(userData.avatar) : undefined,
            isBusiness: false
          });
        }
      }
    };

    fetchUserDisplayData();
  }, [userData, businessData]);

  if (!userDisplayData) {
    return null; // or a loading spinner
  }

  return (
    <Box sx={businessCheckout.headerContainer}>
      <img
        src={userDisplayData.avatar || "/default-avatar.png"}
        style={businessCheckout.image}
        alt={`${userDisplayData.name} avatar`}
      />
      <Typography sx={businessCheckout.firstNameText}>
        {userDisplayData.isBusiness 
          ? `${userDisplayData.name}'s Favorites`
          : `${userData.first_name}'s Favorites`
        }
      </Typography>
      <Typography sx={businessCheckout.listHeadline}>{listHeadline}</Typography>
    </Box>
  );
};